export const LOADING_RAWMATERIAL = "LOADING_RAWMATERIAL";
export const GET_RAWMATERIAL_LIST = "GET_RAWMATERIAL_LIST";
export const GET_RAWMATERIAL_ID = "GET_RAWMATERIAL_ID";
export const REMOVE_RAWMATERIAL = "REMOVE_RAWMATERIAL";
export const ADD_RAWMATERIAL = "ADD_RAWMATERIAL";
export const UPDATE_RAWMATERIAL = "UPDATE_RAWMATERIAL";

export const LOADING_RAWMATERIAL_DOCUMENT = "LOADING_RAWMATERIAL_DOCUMENT";
export const REMOVE_RAWMATERIAL_DOCUMENT = "REMOVE_RAWMATERIAL_DOCUMENT";
export const ADD_RAWMATERIAL_DOCUMENT = "ADD_RAWMATERIAL_DOCUMENT";
export const ADD_RAWMATERIAL_MULTI_DOCUMENT = "ADD_RAWMATERIAL_MULTI_DOCUMENT";
export const DOWNLOAD_RAWMATERIAL_DOCUMENT = "DOWNLOAD_RAWMATERIAL_DOCUMENT";
export const GET_RAWMATERIAL_DOCUMENT_LIST = "GET_RAWMATERIAL_DOCUMENT_LIST";